query Tag($id: ID!) {
  tag(id: $id) {
    id
    title
    description
    path
    type {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    verticalImage {
      id
      url(format: HIGH)
    }
    customFieldValues {
      name
      value
    }
    platformPageId
    platformPage {
      id
      title
      path
      publishAt
    }
    createdAt
    updatedAt
  }
}
